/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GameMode {
  ARAM = 'ARAM',
  ARENA = 'ARENA',
  SUMMONER_RIFT = 'SUMMONER_RIFT',
}

export enum LolChampionBuildItemsListType {
  Boots = 'Boots',
  Core = 'Core',
  Early = 'Early',
  FifthItem = 'FifthItem',
  FirstCore = 'FirstCore',
  FourthItem = 'FourthItem',
  FullBuild = 'FullBuild',
  MythicItem = 'MythicItem',
  SecondCore = 'SecondCore',
  Situational = 'Situational',
  SixthItem = 'SixthItem',
  Starter = 'Starter',
}

export enum LolChampionBuildType {
  ALTERNATIVE = 'ALTERNATIVE',
  HIGHEST_WIN_RATE = 'HIGHEST_WIN_RATE',
  MATCHUP_SPECIFIC = 'MATCHUP_SPECIFIC',
  MOST_POPULAR = 'MOST_POPULAR',
  OFF_META = 'OFF_META',
  OPTIONAL = 'OPTIONAL',
  PRO_PLAYERS = 'PRO_PLAYERS',
  RECOMMENDED = 'RECOMMENDED',
}

export enum LolChampionELO {
  ALL = 'ALL',
  ARAM = 'ARAM',
  HIGH = 'HIGH',
  LOW = 'LOW',
}

export enum Region {
  ALL = 'ALL',
  BR = 'BR',
  EUNE = 'EUNE',
  EUW = 'EUW',
  JP = 'JP',
  KR = 'KR',
  LAN = 'LAN',
  LAS = 'LAS',
  NA = 'NA',
  OCE = 'OCE',
  PBE = 'PBE',
  PH = 'PH',
  RU = 'RU',
  SG = 'SG',
  TH = 'TH',
  TR = 'TR',
  TW = 'TW',
  UNKNOWN = 'UNKNOWN',
  VN = 'VN',
}

export enum Rolename {
  ADC = 'ADC',
  JUNGLE = 'JUNGLE',
  MID = 'MID',
  SUPPORT = 'SUPPORT',
  TOP = 'TOP',
  UNKNOWN = 'UNKNOWN',
}

export enum TierLevel {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  S = 'S',
}

export enum SkillKey {
  E = 'E',
  PASSIVE = 'PASSIVE',
  Q = 'Q',
  R = 'R',
  W = 'W',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
